import React, { useEffect, useState } from "react";
import {
  Modal,
  Typography,
  Table,
  Card,
  Row,
  Col,
  Button,
  message,
} from "antd";
import axios from "axios"; // Import axios or any other HTTP client

const { Title, Text } = Typography;

const OrderDetailsModal = () => {
  const [modalWidth, setModalWidth] = React.useState(1200); // Adjust modal width as needed
  const [orderData, setOrderData] = useState([]);
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    const VendorId = localStorage.getItem("vendor_id");
    setVendorId(VendorId);

    if (VendorId) {
      fetchUnshippingOrders(VendorId);
    }
  }, []);

  const fetchUnshippingOrders = async (vendorId) => {
    try {
      const response = await axios.post(
        "https://app-tl2d3sc25q-uc.a.run.app/api/earningstatus_listing",
        {
          vendorId: vendorId,
        }
      );

      const data = response.data;
      console.log("Vendor Details:", data);
      setOrderData(data); // Store vendor details in state
      console.log("Setting modal visibility to true");
    } catch (error) {
      console.error("Error fetching vendor details:", error);
      // Handle error state if needed
    }
  };
  const columns = [
    {
      title: "Order Id",
      dataIndex: "order_id",
      key: "order_id",
    },
    {
      title: "Date and Time",
      dataIndex: "order_date",
      key: "order_date",
    },
    {
      title: "Total",
      dataIndex: "sub_total",
      key: "sub_total",
      render: (text) => `${text}`,
    },
    {
      title: "Delivery Charge",
      dataIndex: "delivery_charge",
      key: "delivery_charge",
      render: (text) => `${text}`,
    },
    {
      title: "Payment Method",
      dataIndex: "payment_method",
      key: "payment_method",
      render: (text) => `${text}`,
    },
    {
      title: "Cod Charge",
      dataIndex: "cod_charge",
      key: "cod_charge",
      render: (text) => `${text}`,
    },
    {
      title: "Aptope Commission",
      dataIndex: "Aptope_commission",
      key: "Aptope_commission",
      render: (text) => `${text}`,
    },
    {
      title: "GST",
      dataIndex: "gst",
      key: "gst",
      render: (text) => `${text}`,
    },
    {
      title: "Earnings",
      dataIndex: "total_earnings",
      key: "total_earnings",
      render: (text) => `${text}`,
    },
    {
      title: "Status",
      dataIndex: "earnings_status",
      key: "earnings_status",
      render: (text) => `${text}`,
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Card title="Vendor Commission" bordered={false}>
          <Table columns={columns} dataSource={orderData} />
        </Card>
      </Col>
    </Row>
  );
};

export default OrderDetailsModal;
